var _path, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalP2IconTree2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6084 39.3316C56.5004 43.6099 55.226 47.7775 52.923 51.3846C50.6199 54.9917 47.3755 57.9015 43.5399 59.7998C39.7043 61.6982 35.4231 62.5131 31.1584 62.1566C26.8936 61.8001 22.8071 60.2857 19.3399 57.7769C15.8727 55.2681 13.1564 51.8601 11.4842 47.9207C9.81192 43.9813 9.24719 39.66 9.85092 35.4231C10.4546 31.1863 12.2039 27.1947 14.9099 23.8791C17.616 20.5636 21.1761 18.05 25.206 16.6095L33.1159 38.7382L56.6084 39.3316Z",
    stroke: "#D41E4D",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.1167,
    cy: 38.7378,
    r: 23.5,
    transform: "rotate(6.42184 33.1167 38.7378)",
    stroke: "#D41E4D",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.8809,
    cy: 40.5,
    r: 14.5,
    stroke: "#D41E4D",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8809 53L69.3809 70",
    stroke: "#D41E4D",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalP2IconTree2);
export default __webpack_public_path__ + "static/media/Digital_P2_Icon_Tree2.bb42cbdd5fd23f1566c988c711055d2a.svg";
export { ForwardRef as ReactComponent };